var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 12.75C9.21238 12.75 9.3905 12.6781 9.53425 12.5344C9.678 12.3906 9.74988 12.2125 9.74988 12C9.74988 11.7875 9.678 11.6094 9.53425 11.4656C9.3905 11.3219 9.21238 11.25 8.99988 11.25C8.78738 11.25 8.60925 11.3219 8.4655 11.4656C8.32175 11.6094 8.24988 11.7875 8.24988 12C8.24988 12.2125 8.32175 12.3906 8.4655 12.5344C8.60925 12.6781 8.78738 12.75 8.99988 12.75ZM8.24988 9.75H9.74988V5.25H8.24988V9.75ZM8.99988 16.5C7.96238 16.5 6.98738 16.3031 6.07488 15.9094C5.16238 15.5156 4.36863 14.9813 3.69363 14.3063C3.01863 13.6313 2.48425 12.8375 2.0905 11.925C1.69675 11.0125 1.49988 10.0375 1.49988 9C1.49988 7.9625 1.69675 6.9875 2.0905 6.075C2.48425 5.1625 3.01863 4.36875 3.69363 3.69375C4.36863 3.01875 5.16238 2.48438 6.07488 2.09063C6.98738 1.69687 7.96238 1.5 8.99988 1.5C10.0374 1.5 11.0124 1.69687 11.9249 2.09063C12.8374 2.48438 13.6311 3.01875 14.3061 3.69375C14.9811 4.36875 15.5155 5.1625 15.9093 6.075C16.303 6.9875 16.4999 7.9625 16.4999 9C16.4999 10.0375 16.303 11.0125 15.9093 11.925C15.5155 12.8375 14.9811 13.6313 14.3061 14.3063C13.6311 14.9813 12.8374 15.5156 11.9249 15.9094C11.0124 16.3031 10.0374 16.5 8.99988 16.5Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.bada1c531dbd4713140a9afa2b2a8a18.svg";
export { ForwardRef as ReactComponent };